import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';
import { faCog, faDatabase, faDesktop } from "@fortawesome/free-solid-svg-icons";

//Backend Technical Skills
const primaryBackend = [
    "Java",
    "Spring Boot",
    "Spring Security",
    "Spring Data / JPA",
    "Node.js",
    "REST API Design",
    "JWT / Auth0",
    "OAuth / SSO",
    "Microservices",
    "JUnit / Mockito"];

const secondaryBackend = [
    "Spring Batch",
    "Spring Integration",
    "Spring MVC",
    "PHP / Laravel",
    "Python",
    "Hibernate",
    "Maven",
    "Gradle",
    "IBM IIB / MQ",
    "IBM WTX",
    "Tibco BW",
    "SOAP / WSDL"];

//Frontend Technical Skills
const primaryFrontend = [
    "Angular (v16 / v20)",
    "React / Redux",
    "TypeScript",
    "JavaScript / ES6+",
    "RxJS / Observables",
    "HTML5",
    "SCSS / CSS3",
    "Jasmine / Karma"];

const secondaryFrontend = [
    "Vue.js",
    "jQuery",
    "Bootstrap",
    "Webpack",
    "WCAG / Accessibility",
    "Highcharts",
    "Angular CDK",
    "WordPress"
];

//Cloud, Data & DevOps
const primaryDatabaseAndTools = [
    "AWS S3", "AWS Lambda", "AWS EC2",
    "AWS RDS Aurora", "AWS DynamoDB",
    "AWS SQS / SNS", "AWS CloudFormation",
    "AWS API Gateway", "AWS Secrets Manager",
    "MySQL",
    "Redis",
    "Firebase",
    "Snaplogic (ESB/ETL)",
    "Docker",
    "Jenkins",
    "GitHub Actions / CI-CD",
    "Git",
    "Postman",
    "Swagger",
];

//Secondary Cloud, Data & Tools
const secondaryDatabaseAndTools = [
    "Azure Functions",
    "Azure Cosmos DB",
    "Azure Pipelines",
    "MS SQL Server",
    "Elasticsearch",
    "Apache Solr",
    "Flyway",
    "Nexus",
    "SonarQube",
    "Cucumber / Gherkin",
    "SoapUI"
];


function Expertise() {
    return (
        <div className="container" id="expertise">
            <div className="skills-container">
                <h1>Full Stack Engineer</h1>
                <div className="skills-grid">
                    <div className="skill">
                        <FontAwesomeIcon icon={faCog} size="3x" />
                        <h3>Primary Back-End Skills:</h3>
                        <div className="flex-chips">
                            {primaryBackend.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                    <div className="skill">
                        <FontAwesomeIcon icon={faDesktop} size="3x" />
                        <h3>Primary Front-End Skills:</h3>
                        <div className="flex-chips">
                            {primaryFrontend.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                    <div className="skill">
                        <FontAwesomeIcon icon={faDatabase} size="3x" />
                        <h3 className="secondary">Other Primary Technical Skills:</h3>
                        <div className="flex-chips">
                            {primaryDatabaseAndTools.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                    <div className="skill">
                        <h3 className="secondary">Secondary Back-End Skills:</h3>
                        <div className="flex-chips">
                            {secondaryBackend.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                    <div className="skill">
                        <h3 className="secondary">Secondary Front-End Skills:</h3>
                        <div className="flex-chips">
                            {secondaryFrontend.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                    <div className="skill">
                        <h3>Other Secondary Technical Skills:</h3>
                        <div className="flex-chips">
                            {secondaryDatabaseAndTools.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Expertise;